module.exports = __webpack_public_path__ + "img/Prueba.b1907fa0.png";